'use client';
import React, { useEffect, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid2';
import DownloadIcon from '@mui/icons-material/Download';
import CalculateIcon from '@mui/icons-material/Calculate';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Search } from '@mui/icons-material';
import './Index.css';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
  SortDirection,
} from '@mui/material';
import Constants from '../../utils/constants';
import HttpService from '../../services/HttpService';
import { useStore } from '../../utils/store';
import CustomPaginationActionsTable from '../../components/TablePagination';

import { useNavigate } from 'react-router-dom';

import { useSearch } from '../../components/searchContext';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';

import PopOverMenuComponent from '../../components/PopOverMenuComponent';
import ButtonComponent from '../../components/form/ButtonComponent';

import SelectFieldComponent from '../../components/form/SelectFieldComponent';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import TextFieldComponent from '../../components/form/TextFieldComponent';
import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
import AddButtonComponent from '../../components/form/AddButtonComponent';

import DatePickerComponent from '../../components/DatePickerComponent';
import {
  downloadFile,
  formatPrice,
  normalizeDecimalBlur,
} from '../../utils/storageUtil';
import NoActionTable from '../../components/NoActionTable';
import SimpleTabComponent from '../../components/SimpleTabComponent';
import SimpleSearchComponent from '../../components/SimpleSearchComponent';
const MaterialTransferPO: React.FC = () => {
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();
  const [tabIndex, setTabIndex] = useState(0);
  const moreIconMenuItems = [
    { label: 'Details', type: 'detail' },
    { label: 'Download', type: 'download' },
  ];
  const navigate = useNavigate();
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentSelection, setCurrentSelection] = useState('');
  const [currentLocation, setCurrentLocation] = useState<any>(0);
  const [currentDestination, setCurrentDestination] = useState<any>(0);

  const [currentDestinationTransfer, setCurrentDestinationTransfer] =
    useState<any>(0);

  const [PODestination, setPODestination] = useState<any>(0);
  const [locationList, setLocationList] = useState<any[]>([]);
  const [destinationList, setDestinationList] = useState<any[]>([]);
  const [POResourceList, setPOResourceList] = useState<any[]>([]);
  const [quotedItems, setQuotedItems] = useState<any[]>([]);
  const [nonQuotedItems, setNonQuotedItems] = useState<any[]>([]);
  const [transferList, setTransferList] = useState<any[]>([]);
  const [PODialogViewOpen, setPODialogViewOpen] = useState<boolean>(false);
  const [POSendDailogOpen, setPOSendDailogOpen] = useState<boolean>(false);
  const [inProgressSend, setInProgressSend] = useState<boolean>(false);
  const [fileDownloading, setFileDownloading] = useState<any>(null);
  const [inProgress, setInProgress] = useState<boolean>(false);
  const [contractorName, setContractorName] = useState<string>('');
  const [latestPONumber, setLatestPONumber] = useState<string>('');
  const [latestInventoryOrderId, setLatestInventoryOrderId] =
    useState<string>('');

  const [customerEmail, setCustomerEmail] = useState<string>('');
  const [POSubjectName, setPOSubjectName] = useState<string>(
    'Purchase Order No  from Loumac Pro'
  );
  const [currentRecord, setCurrentRecord] = useState<any>(null);

  const [paymentList, setPaymentList] = useState<any[]>([]);
  const [selectedPaymentID, setSelectedPaymentID] = useState<any>(0);
  const [contractorList, setContractorList] = useState<any[]>([]);
  const [selectedContractor, setSelectedContractor] = useState<any>(0);
  const [deliveryDatePO, setDeliveryDatePO] = useState<any>(
    new Date().toISOString().split('T')[0]
  );
  const [orderNote, setOrderNote] = useState<string>('');
  const [moreOpenPO, setMoreOpenPO] = useState<any[]>([]);
  const [transportType, setTransportType] = useState<string>('pickup');
  const [expectedTime, setExpectedTime] = useState<string>('');

  const togglePOBreakdownOpen = (resourceId: any) => {
    setMoreOpenPO((prev) =>
      prev.includes(resourceId)
        ? prev.filter((i) => i !== resourceId)
        : [...prev, resourceId]
    );
  };

  // Allow digits and a single decimal point with up to 2 decimal places.
  const sanitizeDecimal = (raw: any): string => {
    let v = String(raw ?? '').replace(/[^0-9.]/g, '');
    const firstDot = v.indexOf('.');
    if (firstDot !== -1) {
      v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
      const [intPart, decPart] = v.split('.');
      v = intPart + '.' + decPart.slice(0, 2);
    }
    return v;
  };

  const computeBreakdownTotal = (breakdown: any[]) =>
    formatPrice(
      (breakdown || []).reduce(
        (sum: number, b: any) =>
          sum + (Number(b.qty) || 0) * (Number(b.size) || 0),
        0
      )
    );

  const updatePOBreakdown = (resourceId: any, nextBreakdown: any[]) => {
    setPOResourceList((prevItems) => {
      const updated = [...prevItems];
      const idx = updated.findIndex(
        (item: any) => item.resourceId === resourceId
      );
      if (idx === -1) return updated;
      const hasRows = nextBreakdown.length > 0;
      let nextQuantityOrdered = updated[idx].quantityOrdered;
      if (hasRows) {
        const total = computeBreakdownTotal(nextBreakdown);
        nextQuantityOrdered = Number(total) > 0 ? total : '';
      }
      updated[idx] = {
        ...updated[idx],
        quantityBreakdown: nextBreakdown,
        quantityOrdered: nextQuantityOrdered,
        isQuotedItem: false,
      };
      return updated;
    });
  };

  const addBreakdownRow = (row: any) => {
    const current = row.quantityBreakdown || [];
    updatePOBreakdown(row.resourceId, [...current, { qty: '', size: '' }]);
  };

  const removeBreakdownRow = (row: any, index: number) => {
    const current = [...(row.quantityBreakdown || [])];
    current.splice(index, 1);
    updatePOBreakdown(row.resourceId, current);
    if (current.length === 0) {
      setPOResourceList((prevItems) => {
        const updated = [...prevItems];
        const idx = updated.findIndex(
          (item: any) => item.resourceId === row.resourceId
        );
        if (idx !== -1) {
          updated[idx] = {
            ...updated[idx],
            quantityBreakdown: [],
            quantityOrdered: '',
          };
        }
        return updated;
      });
    }
  };

  const changeBreakdownRow = (
    row: any,
    index: number,
    field: 'qty' | 'size',
    value: any
  ) => {
    const current = [...(row.quantityBreakdown || [])];
    current[index] = { ...current[index], [field]: value };
    updatePOBreakdown(row.resourceId, current);
  };

  const clearBreakdown = (row: any) => {
    setPOResourceList((prevItems) => {
      const updated = [...prevItems];
      const idx = updated.findIndex(
        (item: any) => item.resourceId === row.resourceId
      );
      if (idx !== -1) {
        updated[idx] = {
          ...updated[idx],
          quantityBreakdown: [],
          quantityOrdered: '',
        };
      }
      return updated;
    });
  };
  const [disptachDialogViewOpen, setDisptachDialogViewOpen] =
    useState<boolean>(false);

  const [loadingList, setLoadingList] = useState<boolean>(false);
  const [POFormErrorDestination, setPOFormErrorDestination] = useState<any>('');
  const [POFormErrorTerms, setPOFormErrorTerms] = useState<any>('');
  const [POFormErrorContractor, setPOFormErrorContractor] = useState<any>('');
  const [POFormErrorDate, setPOFormErrorDate] = useState<any>('');
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
  const [poResourceSearch, setPoResourceSearch] = useState<string>('');
  const [rows, setRows] = useState<any[]>([]);
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('asc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const [transferDialogViewOpen, setTransferDialogViewOpen] =
    useState<boolean>(false);
  // Table Columns Definition
  const columns: any[] = [
    {
      field: 'orderDate',
      headerName: 'Date',
    },
    {
      field: 'srcName',
      headerName: 'Source',
    },
    {
      field: 'destName',
      headerName: 'Destination',
    },

    {
      field: 'purchaseOrderNumber',
      headerName: 'Transfer/Dispatch/PO ID',
    },
    {
      field: 'orderCategory',
      headerName: 'Type',
    },
    {
      field: 'expectedDeliveryDate',
      headerName: 'Expected Delivery Date',
    },
    {
      field: 'orderStatus',
      headerName: 'Status',
    },
    {
      field: 'inventoryOrderId',
      headerName: '',
      disbleSort: true,
      renderCell: (value: any, row: any) => (
        <PopOverMenuComponent
          handleMenuClick={(type) => {
            handleMoreMenu(type, value, row);
          }}
          menuItems={moreIconMenuItems}
        />
      ),
    },
  ];
  const POColumns: any[] = [
    {
      field: 'name',
      headerName: 'Resource Item Name',
      disableSort: true,
      valueGetter: (value: any, row: any) => {
        return value ? value : row.resourceName;
      },
    },
    {
      field: 'price',
      disableSort: true,
      headerName: 'Unit Price',
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Order',
      disableSort: true,
      renderCell: (value: any, row: any) => {
        const hasBreakdown =
          Array.isArray(row.quantityBreakdown) &&
          row.quantityBreakdown.length > 0;
        const isOpen = moreOpenPO.includes(row.resourceId);
        const calcTooltip = hasBreakdown
          ? 'Edit calculation'
          : 'Add calculation';
        return (
          <Box
            sx={{
              width: 180,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Box sx={{ width: 100 }}>
              <TextFieldComponent
                errorStr=""
                type="text"
                isRequired={false}
                boxStyle={{ marginBottom: 0 }}
                keyName={row.resourceId + '_POOrderQty'}
                label=""
                name={row.resourceId + '_POOrderQty'}
                value={value ?? ''}
                disabled={hasBreakdown}
                onChange={(event: any) => {
                  if (hasBreakdown) return;
                  const intOnly = sanitizeDecimal(event.target.value);
                  const currentIndex = POResourceList.findIndex(
                    (item) => item.resourceId === row.resourceId
                  );
                  setPOResourceList((prevItems) => {
                    const updatedItems = [...prevItems];
                    if (currentIndex !== -1) {
                      updatedItems[currentIndex]['quantityOrdered'] = intOnly;
                      updatedItems[currentIndex]['isQuotedItem'] = false;
                    }
                    return updatedItems;
                  });
                }}
                onBlur={() => {
                  if (hasBreakdown) return;
                  setPOResourceList((prevItems) =>
                    prevItems.map((item) =>
                      item.resourceId === row.resourceId
                        ? {
                            ...item,
                            quantityOrdered: normalizeDecimalBlur(
                              item.quantityOrdered
                            ),
                          }
                        : item
                    )
                  );
                }}
              />
            </Box>
            <Tooltip title={calcTooltip} arrow>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isOpen && !hasBreakdown) {
                    addBreakdownRow(row);
                  }
                  togglePOBreakdownOpen(row.resourceId);
                }}
                sx={{
                  color: hasBreakdown ? '#00bcd4' : 'action.active',
                  backgroundColor: isOpen
                    ? 'rgba(0, 188, 212, 0.08)'
                    : 'transparent',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 188, 212, 0.12)',
                  },
                }}
                aria-label={calcTooltip}
              >
                {hasBreakdown ? (
                  <CalculateIcon fontSize="small" />
                ) : (
                  <CalculateOutlinedIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
            {(hasBreakdown || isOpen) && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  if (hasBreakdown) {
                    clearBreakdown(row);
                  }
                  setMoreOpenPO((prev) =>
                    prev.filter((i) => i !== row.resourceId)
                  );
                }}
                aria-label={
                  hasBreakdown ? 'Clear calculation' : 'Close calculation'
                }
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    {
      field: 'id',
      headerName: 'Total Price',
      disableSort: true,
      renderCell: (value: any, row: any) => {
        const qty = Number(row.quantityOrdered);
        if (!qty || qty <= 0) return <Box>0.00</Box>;
        return <Box>{formatPrice(Number(row.price) * qty)}</Box>;
      },
    },
  ];

  const QuotedColumns: any[] = [
    {
      field: 'resourceName',
      headerName: 'Resource Item',
      disableSort: true,
    },

    {
      field: 'locationName',
      headerName: 'Location',
      disableSort: true,
      valueGetter: (value: any, row: any) => {
        return value ? value : row.srcName;
      },
    },

    {
      field: 'stockLevel',
      headerName: 'Qty in Warehouse',
      disableSort: true,
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Dispatch',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          <TextFieldComponent
            errorStr=""
            type="text"
            isRequired={false}
            keyName={row.resourceId + '_transferQty'}
            label=""
            name={row.resourceId + '_transferQty'}
            value={value ?? ''}
            disabled={Number(row.stockLevel) === 0}
            onChange={(event: any) => {
              const intOnly = sanitizeDecimal(event.target.value);
              const currentIndex = quotedItems.findIndex(
                (item) => item.resourceId === row.resourceId
              );
              setQuotedItems((prevItems) => {
                const updatedItems = [...prevItems];
                if (currentIndex !== -1) {
                  updatedItems[currentIndex]['quantityOrdered'] = intOnly;
                  updatedItems[currentIndex]['isQuotedItem'] = false;
                }
                return updatedItems;
              });
            }}
            onBlur={() => {
              setQuotedItems((prevItems) =>
                prevItems.map((item) =>
                  item.resourceId === row.resourceId
                    ? {
                        ...item,
                        quantityOrdered: normalizeDecimalBlur(
                          item.quantityOrdered
                        ),
                      }
                    : item
                )
              );
            }}
          />
        </Box>
      ),
    },
  ];

  const NonQuotedColumns: any[] = [
    {
      field: 'resourceName',
      headerName: 'Resource Item',
      disableSort: true,
    },
    {
      field: 'locationName',
      headerName: 'Location',
      disableSort: true,
      valueGetter: (value: any, row: any) => {
        return value ? value : row.srcName;
      },
    },

    {
      field: 'stockLevel',
      headerName: 'Qty in Warehouse',
      disableSort: true,
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Dispatch',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          <TextFieldComponent
            errorStr=""
            type="text"
            isRequired={false}
            keyName={row.resourceId + '_transferQty'}
            label=""
            name={row.resourceId + '_transferQty'}
            value={value ?? ''}
            onChange={(event: any) => {
              const intOnly = sanitizeDecimal(event.target.value);
              setNonQuotedItems((prevItems) =>
                prevItems.map((item) =>
                  item.resourceId === row.resourceId
                    ? {
                        ...item,
                        quantityOrdered: intOnly,
                        isQuotedItem: true,
                      }
                    : item
                )
              );
            }}
            onBlur={() => {
              setNonQuotedItems((prevItems) =>
                prevItems.map((item) =>
                  item.resourceId === row.resourceId
                    ? {
                        ...item,
                        quantityOrdered: normalizeDecimalBlur(
                          item.quantityOrdered
                        ),
                      }
                    : item
                )
              );
            }}
          />
        </Box>
      ),
    },
  ];
  const transferColumns: any[] = [
    {
      field: 'id',
      headerName: 'Resource Item',
      disableSort: true,
      renderCell: (value: any, row: any) => <Box>{row.resourceName}</Box>,
    },
    {
      field: 'stockLevel',
      disableSort: true,
      headerName: 'Qty From Source',
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Transfer',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          <TextFieldComponent
            errorStr=""
            type="text"
            isRequired={false}
            keyName={row.resourceId + '_transferQty'}
            label=""
            name={row.resourceId + '_transferQty'}
            value={value ?? ''}
            onChange={(event: any) => {
              const intOnly = sanitizeDecimal(event.target.value);
              const currentIndex = transferList.findIndex(
                (item) => item.resourceId === row.resourceId
              );
              setTransferList((prevItems) => {
                const updatedItems = [...prevItems];
                if (currentIndex !== -1) {
                  updatedItems[currentIndex]['quantityOrdered'] = intOnly;
                }
                return updatedItems;
              });
            }}
            onBlur={() => {
              setTransferList((prevItems) =>
                prevItems.map((item) =>
                  item.resourceId === row.resourceId
                    ? {
                        ...item,
                        quantityOrdered: normalizeDecimalBlur(
                          item.quantityOrdered
                        ),
                      }
                    : item
                )
              );
            }}
          />
        </Box>
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, [searchQuery, paginate]);
  // useEffect(() => {
  //   if (currentLocation === 0) {
  //     setQuotedItems([]);
  //   } else {
  //     handleResourceItems(currentLocation);
  //   }
  // }, [currentLocation]);

  const handleMoreMenu = (type: any, id: any, row: any = null) => {
    if (type === 'detail' && row.orderStatus !== 'draft') {
      navigate(`/inventory/material-transfer-po/${id}`);
    } else if (row.orderStatus === 'draft' && type !== 'download') {
      fetchOrderDetails(row.inventoryOrderId);
    } else if (type === 'download') {
      setLatestInventoryOrderId(row.inventoryOrderId);
      fetchSingleDocument(row.inventoryOrderId);
    } else {
      setDisptachDialogViewOpen(true);
    }
  };
  // Fetch Data
  const fetchData = async () => {
    try {
      await fetchOrders();
      if (locationList.length === 0) await fetchLocations();
      await fetchLocations();
      if (destinationList.length === 0) await fetchDestinations();
      if (paymentList.length === 0) {
        await fetchBundleData();
      }
      if (contractorList.length === 0) {
        await fetchContractors();
      }
    } catch (error: any) {}
  };

  const handlePagination = (paginationData: any) => setPaginate(paginationData);

  const [mailForm, setMailForm] = useState<any>({
    to: customerEmail,
    cc: '',
    subject: POSubjectName,
    body: '',
  });

  // const handleResourceItems = (locationRefId: any) => {
  //   fetchInventory('', locationRefId);
  //   fetchInventory('excludeLocation', locationRefId);
  // };
  const QuotedItems = () => {
    return (
      <Box sx={{ m: 2 }}>
        <Typography variant="h6" sx={{ marginBottom: '20px' }}>
          Quoted Items
        </Typography>
        <CustomPaginationActionsTable
          rows={quotedItems}
          columns={QuotedColumns}
          totalRecords={quotedItems.length}
          isPagingHide={true}
          handlePagination={() => {}}
          handleRowClick={(row: any) => {}}
          handleStatus={() => {}}
          paginationModel={{
            page: paginate.offset,
            pageSize: paginate.limit,
          }}
        />
      </Box>
    );
  };
  const fetchLocations = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/locations/source`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: '', limit: -1, offset: 0, isActive: true }
      );
      //console.log(response);
      if (response.data) {
        const locationDataList: any = [
          { id: 0, label: 'Select Location', locationType: 'all' }, // Default option
          ...response.data.locations
            .map((item: any) => ({
              id: item.locationRefId + '-' + item.locationType,
              label: item.locationName,
              locationType: item.locationType,
            }))
            .sort((a: any, b: any) => a.label.localeCompare(b.label)),
        ];
        setLocationList(locationDataList);
        setCurrentSelection('');
        return true;
      } else {
        setLocationList([]);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const fetchDestinations = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/locations/destination`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: '', limit: -1, offset: 0, isActive: true }
      );
      //console.log(response);
      if (response.data) {
        const locationDataList: any = [
          { id: 0, label: 'Select Destination' }, // Default option
          ...response.data.locations.map((item: any) => ({
            id:
              item.destinationLocationRefId +
              '-' +
              item.destinationLocationType,
            label: item.destinationLocationName,
            locationType: item.destinationLocationType,
          })),
        ];
        setDestinationList(
          locationDataList.sort((a: any, b: any) =>
            a.label.localeCompare(b.label)
          )
        );
        return true;
      } else {
        setDestinationList([]);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  // Round loaded quantityOrdered to 2 decimals so inputs show "25.25"
  // instead of the raw DECIMAL string "25.25000".
  const normalizeOrderQty = (items: any[]) =>
    (items || []).map((item: any) => ({
      ...item,
      quantityOrdered:
        item.quantityOrdered === '' ||
        item.quantityOrdered === null ||
        item.quantityOrdered === undefined
          ? item.quantityOrdered
          : formatPrice(item.quantityOrdered),
    }));
  const handleOrder = (orderDetails: any) => {
    if (orderDetails.orderCategory === 'purchase') {
      setSelectedPaymentID(orderDetails.paymentTerms.id);
      // console.log('hello');
      setPODestination(
        orderDetails.destinationLocationRefId +
          '-' +
          orderDetails.destinationLocationType
      );
      handleContractor(orderDetails.contractor.id, orderDetails.items);
      if (orderDetails.expectedDeliveryDate) {
        const expDateArr = orderDetails.expectedDeliveryDate.split('-');
        if (expDateArr.length > 1)
          setDeliveryDatePO(
            expDateArr[2] + '-' + expDateArr[1] + '-' + expDateArr[0]
          );
      }
      setOrderNote(orderDetails.orderNote ?? '');
      setTransportType(orderDetails.transportType || 'pickup');
      setExpectedTime(orderDetails.expectedTime || '');

      setCurrentRecord(orderDetails);

      setPODialogViewOpen(true);
    }
    if (orderDetails.orderCategory === 'dispatch') {
      setCurrentRecord(orderDetails);
      setCurrentLocation(
        orderDetails.locationRefId + '-' + orderDetails.locationType
      );
      setCurrentDestination(
        orderDetails.destinationLocationRefId +
          '-' +
          orderDetails.destinationLocationType
      );
      setQuotedItems(
        normalizeOrderQty(
          orderDetails.items.filter((item: any) => item.isQuotedItem === 1)
        )
      );
      setNonQuotedItems(
        normalizeOrderQty(
          orderDetails.items.filter((item: any) => item.isQuotedItem === 0)
        )
      );

      setDisptachDialogViewOpen(true);
      changeTabHandler(0);
    }
    if (orderDetails.orderCategory === 'transfer') {
      setCurrentRecord(orderDetails);
      setCurrentDestinationTransfer(
        orderDetails.destinationLocationRefId +
          '-' +
          orderDetails.destinationLocationType
      );
      setTransferList(normalizeOrderQty(orderDetails.items));
      setTransferDialogViewOpen(true);
    }
  };
  const fetchOrderDetails = async (currentId: any) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/orders/${currentId}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {}
      );
      //console.log(response);
      if (response.data) {
        handleOrder(response.data);
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const fetchOrders = async (location: any = null) => {
    try {
      const searchQueries: any = {
        search: searchQuery,
        limit: paginate.limit,
        offset: paginate.offset,
      };
      if (location) {
        searchQueries['orderStatus'] = location;
      }
      setInProgress(true);
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.inventoryURL}/orders`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        searchQueries
      );
      setInProgress(false);
      //console.log(response);
      if (response.data) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      setInProgress(false);
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const fetchPOResourceList = async (contractorId: any, items: any[]) => {
    try {
      const searchQueries: any = {
        search: '',
        limit: -1,
        offset: 0,
      };
      const apiURL = `${Constants.apiURL + Constants.contractorsURL}/${contractorId}/resources`;
      const response = await HttpService.get(
        apiURL,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        searchQueries
      );
      //console.log(response);
      if (response.data) {
        const records = response.data.paginateRecords;
        let recordData = [];
        if (items.length > 0) {
          const normalizedItems = items.map((item: any) => ({
            ...item,
            quantityOrdered:
              item.quantityOrdered === '' ||
              item.quantityOrdered === null ||
              item.quantityOrdered === undefined
                ? item.quantityOrdered
                : formatPrice(item.quantityOrdered),
            quantityBreakdown: Array.isArray(item.quantityBreakdown)
              ? item.quantityBreakdown.map((entry: any) => ({
                  qty: String(parseInt(String(entry.qty ?? '0'), 10) || 0),
                  size: formatPrice(entry.size ?? 0),
                }))
              : [],
          }));
          recordData = [...records, ...normalizedItems];
          recordData = Array.from(
            new Map(recordData.map((item) => [item.resourceId, item])).values()
          );
          setPOResourceList(recordData);
          const preOpenIds = recordData
            .filter(
              (item: any) =>
                Array.isArray(item.quantityBreakdown) &&
                item.quantityBreakdown.length > 0
            )
            .map((item: any) => item.resourceId);
          setMoreOpenPO(preOpenIds);
        } else {
          setPOResourceList(records);
          setMoreOpenPO([]);
        }
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const fetchInventory = async (
    type: string,
    locationRefid: any,
    destinationRefId: any
  ) => {
    try {
      let currentSearchLocationId = locationRefid;
      let currentSearchDestinationId = destinationRefId;
      // if (type === 'PODestination') {
      currentSearchLocationId = locationRefid.split('-')[0];
      currentSearchDestinationId = destinationRefId.split('-')[0];
      // }
      const searchQueries: any = {
        search: '',
        limit: -1,
        offset: 0,
        sourceLocationType: getLocation(locationRefid, 'source').locationType,
        sourceLocationRefId: currentSearchLocationId,
        destinationLocationRefId: currentSearchDestinationId,
        destinationLocationType: getLocation(destinationRefId, 'destination')
          .locationType,
      };

      // if (type === 'excludeLocation') {
      //   endPoint = `/${type}`;
      // }

      const apiURL = `${Constants.apiURL + Constants.inventoryURL}/items/${type}`;
      const response = await HttpService.get(
        apiURL,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        searchQueries
      );
      //console.log(response);
      if (response.data) {
        // if (type === 'excludeLocation')
        //   setNonQuotedItems(response.data.paginateRecords);
        // else
        //   setQuotedItems(
        //     response.data.paginateRecords.filter(
        //       (item: any) => item.stockLevel > 0
        //     )
        //   );
        if (currentRecord) {
          const ExistingQuotedItems = currentRecord.items.filter(
            (item: any) => item.isQuotedItem > 0
          );

          const existingNonQuoteItems = currentRecord.items.filter(
            (item: any) => item.isQuotedItem === 0
          );
          if (type === 'nonQuoted') {
            let nonMergeData: any = [
              ...response.data.paginateRecords,
              ...existingNonQuoteItems,
            ];
            nonMergeData = Array.from(
              new Map(
                nonMergeData.map((item: any) => [item.resourceId, item])
              ).values()
            );
            setNonQuotedItems(response.data.paginateRecords);
          } else {
            let MergeData: any = [
              ...response.data.paginateRecords,
              ...ExistingQuotedItems,
            ];
            MergeData = Array.from(
              new Map(
                MergeData.map((item: any) => [item.resourceId, item])
              ).values()
            );
            setQuotedItems(MergeData);
          }
        } else {
          if (type === 'nonQuoted')
            setNonQuotedItems(response.data.paginateRecords);
          else
            setQuotedItems(
              response.data.paginateRecords.filter(
                (item: any) => item.stockLevel > 0
              )
            );
        }

        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const getLocation = (id: any, type: string) => {
    const locationFound =
      type === 'source'
        ? locationList.findIndex((item) => item.id === id)
        : destinationList.findIndex((item) => item.id === id);
    //(locationFound);
    if (locationFound !== -1) {
      //  console.log(locationList[locationFound], '------------');
      return type === 'source'
        ? locationList[locationFound]
        : destinationList[locationFound];
    } else {
      return null;
    }
  };
  const getLocationAndType = (locationData: any) => {
    const locationArr = locationData.split('-');
    if (locationArr.length > 1) {
      return { location: locationArr[0], type: locationArr[1] };
    } else {
      return { location: locationArr[0], type: '' };
    }
  };
  const handleDispatchOrder = async (type: string) => {
    try {
      const itemsQuoted: any[] = quotedItems
        .filter((item: any) => item.quantityOrdered > 0)
        .map((item: any) => ({
          resourceId: item.resourceId,
          quantityOrdered: item.quantityOrdered,
          isQuotedItem: true,
        }));

      const itemsNONQuoted: any[] = nonQuotedItems
        .filter((item: any) => item.quantityOrdered > 0)
        .map((item: any) => ({
          resourceId: item.resourceId,
          quantityOrdered: item.quantityOrdered,
          isQuotedItem: false,
        }));
      const items = [...itemsNONQuoted, ...itemsQuoted];

      if (items.length === 0) {
        setAlert({
          type: 'error',
          message: 'at least one quantity is required',
          open: true,
        });
        return false;
      }
      if (currentDestination === 0 || currentLocation === 0) {
        setAlert({
          type: 'error',
          message: 'Destination and Source both are required field',
          open: true,
        });
        return false;
      }
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      const srcLocation = getLocationAndType(currentLocation);
      const destLocation = getLocationAndType(currentDestination);
      const postData: any = {
        locationRefId: srcLocation.location,
        locationType: srcLocation.type,
        destinationLocationRefId: destLocation.location,
        destinationLocationType: destLocation.type,
        orderDate: formattedDate,
        orderCategory: 'dispatch',
        orderStatus: type,
        items: items,
      };
      if (currentRecord) {
        postData['inventoryOrderId'] = currentRecord.inventoryOrderId;
      }
      setInProgressSend(true);
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpService.post(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
      }
      setDisptachDialogViewOpen(false);
      setInProgressSend(false);
      fetchData();
      setAlert({
        type: 'success',
        open: true,
        message: 'Saved Successfully',
      });
      setCurrentRecord(null);
    } catch (error: any) {
      setAlert({
        type: 'error',
        open: true,
        message: error.message,
      });
      setInProgressSend(false);
    }
  };
  const NonQuotedItems = () => {
    return (
      <Box sx={{ m: 2 }}>
        <Typography variant="h6" sx={{ marginBottom: '20px' }}>
          Non-quoted Items
        </Typography>
        <CustomPaginationActionsTable
          rows={nonQuotedItems}
          columns={NonQuotedColumns}
          totalRecords={2}
          isPagingHide={true}
          handlePagination={() => {}}
          handleRowClick={(row: any) => {}}
          handleStatus={() => {}}
          handleCheckBoxChange={() => {}}
          paginationModel={{
            page: paginate.offset,
            pageSize: paginate.limit,
          }}
        />
      </Box>
    );
  };
  const fetchContractors = async () => {
    try {
      setLoadingList(true);
      const response = await HttpService.get(
        Constants.apiURL + Constants.contractorsURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setContractorList([
          { id: 0, label: 'Select Contractor' }, // Default option
          ...response.data.paginateRecords.map((item: any) => ({
            id: item.id,
            name: item.name,
            email: item.email,
          })),
        ]);
      }
      setLoadingList(false);
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setLoadingList(false);
    }
  };
  const fetchBundleData = async () => {
    try {
      setLoadingList(true);
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.refBundleURL}/fetchInventoryPaymentTerms`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      //console.log(response);
      if (response.data) {
        setPaymentList([
          { id: 0, name: 'Select Payment Term' },
          ...response.data,
        ]);
      }
      setLoadingList(false);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setLoadingList(false);
    }
  };
  const TabContent = () => {
    return (
      <Box>
        {tabIndex === 0 && <QuotedItems></QuotedItems>}
        {tabIndex === 1 && <NonQuotedItems></NonQuotedItems>}
      </Box>
    );
  };
  const changeTabHandler = async (newIndex: number) => setTabIndex(newIndex);

  const handleDispatchLocationChange = (id: any, type: any) => {
    let destination: any = 0;
    let source: any = 0;
    if (type === 'source') {
      setCurrentLocation(id);
      setDestinationList(destinationList.filter((item) => item.id !== id));
      if (id !== 0 && currentDestination !== 0) {
        source = id;
        destination = currentDestination;
      }
    }
    if (type === 'destination') {
      setCurrentDestination(id);
      if (id !== 0 && currentLocation !== 0) {
        source = currentLocation;
        destination = id;
      }
    }
    if (source !== 0 && destination !== 0) {
      fetchInventory('quoted', source, destination);
      fetchInventory('nonQuoted', source, destination);
    }
  };
  const DisptachDialogView = () => {
    return (
      <Box sx={{ width: '700px' }}>
        <Grid container spacing={1} sx={{ marginBottom: '20px' }}>
          <Grid size={6}>
            {currentRecord && (
              <Box>
                <h3 className="ovreview-label">Source</h3>
                <h2 style={{ fontWeight: 'normal', fontSize: '18px' }}>
                  {currentRecord.srcName}
                </h2>
              </Box>
            )}
            {!currentRecord && (
              <SelectFieldComponent
                errorStr=""
                isRequired={false}
                keyName={'drpsourcePO'}
                label="Source"
                name={'drpsourcePO'}
                value={currentLocation}
                items={locationList}
                onChange={(event: any) => {
                  handleDispatchLocationChange(event.target.value, 'source');
                }}
              />
            )}
          </Grid>
          <Grid size={6}>
            {currentRecord && (
              <Box>
                <h3 className="ovreview-label">Destination</h3>
                <h2 style={{ fontWeight: 'normal', fontSize: '18px' }}>
                  {currentRecord.destName}
                </h2>
              </Box>
            )}
            {!currentRecord && (
              <SelectFieldComponent
                errorStr=""
                isRequired={false}
                keyName={'destsourcePO'}
                label="Destination"
                name={'destsourcePO'}
                value={currentDestination}
                items={destinationList}
                onChange={(event: any) => {
                  handleDispatchLocationChange(
                    event.target.value,
                    'destination'
                  );
                }}
              />
            )}
          </Grid>
        </Grid>
        <SimpleTabComponent
          currentTab={tabIndex}
          labels={['Quoted items', 'Non-quoted items']}
          tabContent={<Box></Box>}
          onChangeTab={changeTabHandler}
        />
        {tabIndex == 0 && (
          <Box sx={{ m: 2 }}>
            <Typography variant="h6" sx={{ marginBottom: '20px' }}>
              Quoted Items
            </Typography>
            <CustomPaginationActionsTable
              rows={quotedItems}
              columns={QuotedColumns}
              totalRecords={quotedItems.length}
              isPagingHide={true}
              handlePagination={() => {}}
              handleRowClick={(row: any) => {}}
              handleStatus={() => {}}
              paginationModel={{
                page: paginate.offset,
                pageSize: paginate.limit,
              }}
            />
          </Box>
        )}
        {tabIndex == 1 && (
          <Box sx={{ m: 2 }}>
            <Typography variant="h6" sx={{ marginBottom: '20px' }}>
              Non-quoted Items
            </Typography>
            <CustomPaginationActionsTable
              rows={nonQuotedItems}
              columns={NonQuotedColumns}
              totalRecords={2}
              isPagingHide={true}
              handlePagination={() => {}}
              handleRowClick={(row: any) => {}}
              handleStatus={() => {}}
              handleCheckBoxChange={() => {}}
              paginationModel={{
                page: paginate.offset,
                pageSize: paginate.limit,
              }}
            />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'flex-end',
            justifyContent: 'end',
            m: 2,
          }}
        >
          <ButtonComponent
            onClick={() => {
              handleDispatchOrder('draft');
              // setDisptachDialogViewOpen(false);
            }}
            disabled={inProgressSend}
            label={inProgressSend ? 'Sending...' : 'Save'}
          />
          <ButtonComponent
            onClick={() => {
              handleDispatchOrder('pending');
            }}
            disabled={inProgressSend}
            label={inProgressSend ? 'Saving...' : 'Submit'}
          />
        </Box>
      </Box>
    );
  };
  const handlePOSendDialog = () => {
    setPOSendDailogOpen(false);
    setInProgressSend(false);
    fetchData();
    setAlert({
      type: 'success',
      open: true,
      message: 'Saved Successfully',
    });
    clearPOForm();
  };
  const handleChangeMailBody = (e: any) => {
    const { name, value } = e.target;

    setMailForm((prev: any) => {
      return { ...prev, [name]: value };
    });
  };
  const mailcontentHTML = () => {
    const escapeHtml = (text: string) =>
      String(text ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    const noteHtml =
      orderNote && orderNote.trim()
        ? `
        <div style="margin: 16px 0; padding: 12px 16px; background-color: #ffffff; border-left: 3px solid #00bcd4; border-radius: 4px;">
          <p style="font-size: 14px; font-weight: 600; margin: 0 0 6px; color: #1f2d3d;">Order Note</p>
          <p style="font-size: 14px; margin: 0; color: #333; white-space: pre-wrap;">${escapeHtml(orderNote).replace(/\n/g, '<br/>')}</p>
        </div>`
        : '';
    return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; padding: 20px; background-color: #f9f9f9;">
      <div style="max-width: 900px;">
        <p style="font-size: 16px; margin: 0 0 10px;">${contractorName},</p>
        <p style="font-size: 16px; margin: 0 0 10px;">
         hope this email finds you well.Please find attached Purchase Order ${latestPONumber} for your review and action. Kindly confirm receipt and acknowledge acceptance of the terms outlined in the order.

        </p>
        <p style="font-size: 16px; margin: 0 0 10px;">If you have any questions or require further clarification, please do not hesitate to contact us.</p>
         <p style="font-size: 16px; margin: 0 0 10px;">We appreciate your prompt attention to this matter and look forward to your confirmation.</p>
          <p style="font-size: 16px; margin: 0 0 10px;"></p>
        ${noteHtml}
        <p style="font-size: 16px; font-weight: bold; margin: 0;">Regards,</p>
        <p style="font-size: 16px; margin: 0;">Loumac</p>

      </div>
    </div>

  `;
  };
  const fetchSingleDocument = async (id: any = null) => {
    try {
      setFileDownloading(true);
      setInProgress(true);
      const orderId = id ? id : latestInventoryOrderId;
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/purchaseOrder/${orderId}`;
      const response = await HttpService.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });
      setFileDownloading(false);
      setInProgress(false);
      if (response) {
        downloadFile(response, 'PURCHASEORDER_' + orderId + '.pdf');
        window.open(response.data, '_blank');
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setFileDownloading(false);
      setInProgress(false);
    }
  };
  const dialogPOSend = () => {
    return (
      <Box className="mt-2">
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '20px',
            width: '900px',
            border: '3px solid #efeeed',
            borderRadius: '10px',
            backgroundColor: '#f9f9f9',
            padding: '20px',
          }}
        >
          <Grid size={12} sx={{ mt: 2 }}>
            <TextField
              label="To"
              name="to"
              value={mailForm.to}
              sx={{ width: '100%', background: '#f9f9f9', paddingLeft: '2px' }}
              variant="standard"
              onChange={handleChangeMailBody}
            />
          </Grid>
          <Grid size={12} sx={{ mt: 2 }}>
            <TextField
              label="CC"
              name="cc"
              value={mailForm.cc}
              sx={{ width: '100%', background: '#f9f9f9', paddingLeft: '2px' }}
              variant="standard"
              onChange={handleChangeMailBody}
            />
          </Grid>
          <Grid size={12} sx={{ mt: 2 }}>
            <TextField
              label="Subject"
              value={mailForm.subject}
              name="subject"
              sx={{ width: '100%', background: '#f9f9f9', paddingLeft: '2px' }}
              variant="standard"
              onChange={handleChangeMailBody}
            />
          </Grid>
          <Grid size={12}>
            <Box
              dangerouslySetInnerHTML={{ __html: mailcontentHTML() }}
              sx={{}}
            />
          </Grid>
          <Grid size={12}>
            <Box>
              <Typography component={'h6'} className="projectItemMainTitle">
                Purchase Order PDF
              </Typography>

              <Grid container spacing={2}>
                <Grid size={12}>
                  <Box
                    sx={{
                      backgroundColor: 'rgba(0, 244, 255, 0.08)',
                      color: '#000',
                      margin: '5px',
                      padding: '5px 12px',
                      width: '450px',
                      border: '1px solid #4ca7f6',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <p style={{ fontWeight: 'bold', fontSize: '12px' }}>
                        {'Order-' + latestPONumber}
                      </p>
                      <p
                        style={{
                          paddingBottom: '10px',
                          fontSize: '12px',
                          color: '#666',
                        }}
                      >
                        {latestPONumber}
                      </p>
                    </Box>
                    <Box>
                      <IconButton
                        aria-label="close"
                        onClick={() => {
                          fetchSingleDocument();
                        }}
                      >
                        {fileDownloading ? (
                          <CircularProgress size={24} />
                        ) : (
                          <DownloadIcon />
                        )}
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>

                <Divider sx={{ mt: 2, mb: 2 }} />
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <ButtonComponent
            keyName={'addBtn'}
            errors={[]}
            onClick={() => {
              sendPOMail();
            }}
            label={inProgressSend ? 'Sending...' : 'Send'}
          />
        </Box>
      </Box>
    );
  };
  const clearPOForm = () => {
    setPODestination(0);
    setSelectedPaymentID(0);
    setSelectedContractor(0);
    setPOResourceList([]);
    setDeliveryDatePO(new Date().toISOString().split('T')[0]);
    setOrderNote('');
    setMoreOpenPO([]);
    setTransportType('pickup');
    setExpectedTime('');
    setPOFormErrorDestination('');
    setPOFormErrorTerms('');
    setPOFormErrorContractor('');
    setPOFormErrorDate('');
    setCurrentRecord(null);
    setInProgressSend(false);
  };
  const handlePOFormSave = async (type: string) => {
    try {
      if (parseInt(PODestination) === 0) {
        setPOFormErrorDestination('Destination is required field');
        return;
      }
      if (parseInt(selectedPaymentID) === 0) {
        setPOFormErrorTerms('Payment Term is required field');
        return;
      }
      if (parseInt(selectedContractor) === 0) {
        setPOFormErrorContractor('Contractor is required field');
        return;
      }
      if (!deliveryDatePO) {
        setPOFormErrorDate('Expected Delivery Date is required field');
        return;
      }
      const poDestinationID = PODestination.split('-')[0];
      const items: any[] = POResourceList.filter(
        (item: any) => item.quantityOrdered > 0
      ).map((item: any) => ({
        resourceId: item.resourceId,
        quantityOrdered: item.quantityOrdered,
        isQuotedItem: false,
        quantityBreakdown: Array.isArray(item.quantityBreakdown)
          ? item.quantityBreakdown
              .filter(
                (b: any) =>
                  (Number(b.qty) || 0) > 0 && (Number(b.size) || 0) > 0
              )
              .map((b: any) => ({
                qty: Number(b.qty),
                size: Number(b.size),
              }))
          : [],
      }));
      if (items.length === 0) {
        setAlert({
          type: 'error',
          message: 'at least one quantity is required',
          open: true,
        });
        return false;
      }
      setInProgressSend(true);
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      const postData: any = {
        destinationLocationRefId: poDestinationID,
        destinationLocationType: getLocation(PODestination, 'destination')
          .locationType,
        paymentTermsId: selectedPaymentID,
        contractorId: selectedContractor,
        expectedDeliveryDate: deliveryDatePO,
        transportType: transportType,
        expectedTime: expectedTime || null,
        orderDate: formattedDate,
        orderCategory: 'purchase',
        orderStatus: 'draft',
        orderNote: orderNote,
        items: items,
      };
      if (currentRecord) {
        postData['inventoryOrderId'] = currentRecord.inventoryOrderId;
      }
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpService.post(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        setLatestPONumber(response.data.purchaseOrderNumber);
        setLatestInventoryOrderId(response.data.inventoryOrderId);

        setMailForm((prev: any) => {
          return {
            ...prev,

            subject:
              'Purchase Order No ' +
              response.data.purchaseOrderNumber +
              '  from Loumac Pro',
          };
        });
        if (type === 'send') {
          setPODialogViewOpen(false);
          setPOSendDailogOpen(true);
          setInProgressSend(false);
        } else {
          setPODialogViewOpen(false);
          setInProgressSend(false);
          fetchData();
          setAlert({
            type: 'success',
            open: true,
            message: 'Saved Successfully',
          });
          clearPOForm();
        }
      }
    } catch (e: any) {
      setInProgressSend(false);
      setAlert({
        type: 'success',
        open: true,
        message: e.message,
      });
    }
    let errorMessage = '';
    return errorMessage;
  };
  const sendPOMail = async () => {
    try {
      setInProgressSend(true);
      const postData: any = {
        toemails: [mailForm.to],
        ccemails: [mailForm.cc],
        htmlbody: mailcontentHTML(),
        subject: mailForm.subject,
        inventoryOrderId: latestInventoryOrderId,
      };

      const response = await HttpService.post(
        `${Constants.apiURL}/email/sendPurchaseOrder`,
        postData,
        {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        }
      );

      //console.log(response);
      if (response.success) {
        handlePOSendDialog();

        return true;
      } else {
        setInProgressSend(false);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const handleContractor = (id: any, items: any) => {
    setSelectedContractor(id);
    setPoResourceSearch('');
    const contractorIdx = contractorList.findIndex(
      (item: any) => item.id === id
    );
    if (contractorIdx !== -1) {
      setContractorName(contractorList[contractorIdx]['name']);
      setCustomerEmail(contractorList[contractorIdx]['email']);
      setMailForm({
        subject: `Purchase Order No  from Loumac Pro`,
        to: contractorList[contractorIdx]['email'],
        cc: '',
        body: '',
      });
    }
    if (id !== 0) {
      fetchPOResourceList(id, items);
    }
  };
  const renderPOBreakdown = (row: any) => {
    const breakdown: any[] = row.quantityBreakdown || [];
    return (
      <Box
        sx={{
          margin: 1,
          padding: 2,
          border: 1,
          borderColor: '#efeeed',
          borderRadius: 1,
          backgroundColor: '#fafafa',
        }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Calculation
        </Typography>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid size={4}>
            <Typography variant="caption">Qty</Typography>
          </Grid>
          <Grid size={1}></Grid>
          <Grid size={3}>
            <Typography variant="caption">Size</Typography>
          </Grid>
          <Grid size={1}></Grid>
          <Grid size={2}>
            <Typography variant="caption">Subtotal</Typography>
          </Grid>
          <Grid size={1}></Grid>
        </Grid>
        {breakdown.map((entry: any, i: number) => (
          <Grid
            container
            spacing={1}
            sx={{ mb: 1, alignItems: 'center' }}
            key={`breakdown_${row.resourceId}_${i}`}
          >
            <Grid size={4}>
              <TextField
                size="small"
                type="text"
                fullWidth
                value={entry.qty ?? ''}
                onChange={(e) =>
                  changeBreakdownRow(
                    row,
                    i,
                    'qty',
                    String(e.target.value).replace(/\D/g, '')
                  )
                }
              />
            </Grid>
            <Grid size={1} sx={{ display: 'flex', justifyContent: 'center' }}>
              ×
            </Grid>
            <Grid size={3}>
              <TextField
                size="small"
                type="text"
                fullWidth
                value={entry.size ?? ''}
                onChange={(e) =>
                  changeBreakdownRow(
                    row,
                    i,
                    'size',
                    sanitizeDecimal(e.target.value)
                  )
                }
                onBlur={() =>
                  changeBreakdownRow(
                    row,
                    i,
                    'size',
                    normalizeDecimalBlur(entry.size)
                  )
                }
              />
            </Grid>
            <Grid size={1} sx={{ display: 'flex', justifyContent: 'center' }}>
              =
            </Grid>
            <Grid size={2}>
              {formatPrice(
                (Number(entry.qty) || 0) * (Number(entry.size) || 0)
              )}
            </Grid>
            <Grid size={1}>
              <IconButton
                size="small"
                onClick={() => removeBreakdownRow(row, i)}
                aria-label="Remove row"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Box sx={{ mt: 1 }}>
          <Button
            size="small"
            startIcon={<AddIcon />}
            onClick={() => addBreakdownRow(row)}
          >
            Add row
          </Button>
        </Box>
      </Box>
    );
  };
  const filteredPOResourceList = useMemo(() => {
    if (!poResourceSearch) return POResourceList;
    const q = poResourceSearch.toLowerCase();
    return POResourceList.filter((r) => {
      const name = (r.name ?? r.resourceName ?? '').toString().toLowerCase();
      return name.includes(q);
    });
  }, [POResourceList, poResourceSearch]);

  const PODialogView = () => {
    return (
      <Box sx={{ width: '700px' }}>
        <Grid container spacing={1} sx={{ marginBottom: '20px' }}>
          <Grid size={6}>
            <SelectFieldComponent
              errorStr={POFormErrorDestination}
              isRequired={true}
              keyName={'destsourcePO'}
              label="Destination"
              name={'destsourcePO'}
              value={PODestination}
              items={destinationList}
              onChange={(event: any) => {
                setPODestination(event.target.value);
              }}
            />
          </Grid>
          <Grid size={6}>
            <SelectFieldComponent
              errorStr={POFormErrorTerms}
              isRequired={true}
              keyName={'drpsourcePOPayment'}
              label="Payment Terms"
              name={'drpsourcePOPayment'}
              value={selectedPaymentID}
              items={paymentList}
              onChange={(event: any) => {
                setSelectedPaymentID(event.target.value);
              }}
            />
          </Grid>
          <Grid size={6}>
            {currentRecord && currentRecord.contractor && (
              <Box>
                <h3 className="ovreview-label">Contractor / Supplier</h3>
                <h2 style={{ fontWeight: 'normal', fontSize: '18px' }}>
                  {currentRecord.contractor.name}
                </h2>
              </Box>
            )}

            {!currentRecord && (
              <SelectFieldComponent
                errorStr={POFormErrorContractor}
                isRequired={true}
                keyName={'POContractorList'}
                label="Contractor / Supplier"
                name={'POContractorList'}
                value={selectedContractor}
                items={contractorList}
                onChange={(event: any) => {
                  handleContractor(
                    event.target.value,
                    currentRecord ? currentRecord.items : []
                  );
                }}
              />
            )}
          </Grid>
          <Grid size={6}>
            <DatePickerComponent
              errorStr={POFormErrorDate}
              isRequired={true}
              keyName={'deliveryDatePO'}
              label="Expected Delivery Date"
              name={'deliveryDatePO'}
              defaultValue={deliveryDatePO}
              onChange={(val) => {
                console.log(val, 'deliveryDatePO');
                setDeliveryDatePO(val);
              }}
            />
          </Grid>
          <Grid size={6}>
            <Box sx={{ mb: 1 }} className="form-label">
              Transport Type
            </Box>
            <FormControl>
              <RadioGroup
                row
                name="transportType"
                value={transportType}
                onChange={(e) => setTransportType(e.target.value)}
              >
                <FormControlLabel
                  value="pickup"
                  control={<Radio />}
                  label="Pick Up"
                />
                <FormControlLabel
                  value="delivery"
                  control={<Radio />}
                  label="Delivery"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid size={6}>
            <Box sx={{ mb: 1 }} className="form-label">
              Expected Time
            </Box>
            <TextField
              type="time"
              size="small"
              fullWidth
              name="expectedTime"
              value={expectedTime}
              onChange={(e) => setExpectedTime(e.target.value)}
              inputProps={{ step: 300 }}
            />
          </Grid>
          {currentRecord && (
            <Grid size={6}>
              <Box sx={{ mb: 3 }}>
                PO Number : {currentRecord.purchaseOrderNumber}
              </Box>
            </Grid>
          )}
          {currentRecord && (
            <Grid size={6}>
              <Box sx={{ mb: 3 }}>Order Date : {currentRecord.orderDate}</Box>
            </Grid>
          )}
          <Grid size={12}>
            <TextFieldAreaComponent
              keyName={'orderNotePO'}
              name={'orderNotePO'}
              label="Order Note"
              isRequired={false}
              value={orderNote}
              minRows={3}
              onChange={(event: any) => {
                setOrderNote(event.target.value);
              }}
            />
          </Grid>
        </Grid>

        {selectedContractor !== 0 && (
          <Box sx={{ mb: 1 }}>
            <TextField
              placeholder="Search resources..."
              size="small"
              value={poResourceSearch}
              onChange={(e) => setPoResourceSearch(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
              sx={{ width: 350 }}
            />
          </Box>
        )}

        <CustomPaginationActionsTable
          rows={filteredPOResourceList}
          columns={POColumns}
          totalRecords={POResourceList.length}
          isPagingHide={true}
          handlePagination={() => {}}
          handleRowClick={(row: any) => {}}
          handleStatus={() => {}}
          handleCheckBoxChange={() => {}}
          paginationModel={{
            page: paginate.offset,
            pageSize: paginate.limit,
          }}
          isMore={true}
          moreOpen={filteredPOResourceList
            .map((item: any, idx: number) =>
              moreOpenPO.includes(item.resourceId) ? idx : -1
            )
            .filter((idx: number) => idx !== -1)}
          renderExpanded={(row: any) => renderPOBreakdown(row)}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'flex-end',
            justifyContent: 'end',
            m: 2,
          }}
        >
          <ButtonComponent
            onClick={() => {
              handlePOFormSave('send');
              // setDisptachDialogViewOpen(false);
            }}
            disabled={inProgressSend}
            label={inProgressSend ? 'Sending...' : 'Send'}
          />
          <ButtonComponent
            onClick={() => {
              handlePOFormSave('save');
            }}
            disabled={inProgressSend}
            label={inProgressSend ? 'Saving...' : 'Save'}
          />
        </Box>
      </Box>
    );
  };
  const handleCurrentSelection = (type: string) => {
    if (currentSelection !== type) {
      setCurrentSelection(type);
      fetchOrders(type);

      return;
    }
    if (currentSelection === currentSelection) {
      setCurrentSelection('');
      fetchOrders();
      return;
    }
  };
  const handleTransfer = async (type: any) => {
    try {
      const items: any[] = transferList
        .filter((item: any) => item.quantityOrdered > 0)
        .map((item: any) => ({
          resourceId: item.resourceId,
          quantityOrdered: item.quantityOrdered,
          isQuotedItem: false,
        }));

      if (items.length === 0 || items.includes(undefined)) {
        setAlert({
          type: 'error',
          message: 'at least one quantity is required',
          open: true,
        });
        return false;
      }
      if (currentDestinationTransfer === 0) {
        setAlert({
          type: 'error',
          message: 'Destination is required field',
          open: true,
        });
        return false;
      }

      const destLocation = getLocationAndType(currentDestinationTransfer);
      const postData = {
        locationRefId: currentRecord.locationRefId,
        locationType: currentRecord.locationType,
        destinationLocationRefId: destLocation.location,
        destinationLocationType: destLocation.type,
        orderDate: currentRecord.orderDate,
        orderCategory: 'transfer',
        orderStatus: type,
        items: items,
        inventoryOrderId: currentRecord.inventoryOrderId,
      };
      setInProgressSend(true);
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpService.post(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        clearTransfer();
      }
      setInProgressSend(false);
    } catch (error: any) {
      setInProgressSend(false);
    }
  };
  const clearTransfer = () => {
    setAlert({ type: 'success', message: 'Saved Successfully', open: true });
    window.location.reload();
  };
  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>Are you sure you want to transfer items to another Warehouse?</h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label={'Confirm'}
            onClick={async () => {
              handleTransfer('pending');
              // setTransferDialogViewOpen(false);
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  const transferDialogView = () => {
    return (
      <Box sx={{ width: '600px' }}>
        <Grid container spacing={2}>
          <Grid size={5}>
            <h3 className="ovreview-label">Source</h3>
            {currentRecord && (
              <h2 style={{ fontWeight: 'normal', fontSize: '18px' }}>
                {currentRecord.srcName}
              </h2>
            )}
          </Grid>

          <Grid size={7}>
            <h3 className="ovreview-label">{'Destination'}</h3>
            <SelectFieldComponent
              errorStr=""
              isRequired={false}
              keyName={'destsource'}
              label=""
              name={'destsource'}
              value={currentDestinationTransfer}
              items={destinationList}
              onChange={(e: any) => {
                setCurrentDestinationTransfer(e.target.value);
              }}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ m: 1 }}>
          Resource Items
        </Typography>
        <NoActionTable
          rows={transferList}
          columns={transferColumns}
          handleRowClick={(row: any) => {}}
          handleStatus={() => {}}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'flex-end',
            justifyContent: 'end',
            m: 2,
          }}
        >
          <ButtonComponent
            onClick={() => {
              //  setTransferDialogViewOpen(false);
              setConfirmDailogOpen(true);
            }}
            label={inProgressSend ? 'Saving...' : 'Submit'}
          />
          <ButtonComponent
            onClick={() => {
              //  setTransferDialogViewOpen(false);
              handleTransfer('draft');
            }}
            label={inProgressSend ? 'Saving...' : 'Save'}
          />
        </Box>
      </Box>
    );
  };
  return (
    <Stack>
      <Box id="main" className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <Typography variant="h6" sx={{ m: 2 }}>
              Material Transfer/PO Dashboard
            </Typography>
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">All Orders</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <AddButtonComponent
                    onClick={() => {
                      setDisptachDialogViewOpen(true);
                    }}
                    keyName="quoteaddicon"
                    label="Dispatch Order"
                  />
                  <AddButtonComponent
                    onClick={async () => {
                      setPODialogViewOpen(true);
                    }}
                    keyName="quoteaddicon"
                    label={'Purchase Order'}
                  />
                </Box>
              </Box>
              {inProgress && (
                <Box sx={{ width: '100%', textAlign: 'center' }}>
                  <LinearProgress />
                </Box>
              )}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: '',
                  alignItems: 'baseline',
                  padding: '10px',
                  background: '#f9f9f9',
                  mb: 2,
                  gap: 2,
                }}
              >
                <Typography>Status</Typography>
                <Button
                  variant="outlined"
                  className={currentSelection === 'draft' ? 'isActiveBtn' : ''}
                  onClick={() => {
                    handleCurrentSelection('draft');
                  }}
                >
                  Draft
                </Button>
                <Button
                  variant="outlined"
                  className={
                    currentSelection === 'pending' ? 'isActiveBtn' : ''
                  }
                  onClick={() => {
                    handleCurrentSelection('pending');
                  }}
                >
                  Pending
                </Button>
                <Button
                  variant="outlined"
                  className={
                    currentSelection === 'completed' ? 'isActiveBtn' : ''
                  }
                  onClick={() => {
                    handleCurrentSelection('completed');
                  }}
                >
                  Complete
                </Button>
              </Box>
              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={totalRecords}
                handlePagination={handlePagination}
                handleRowClick={(row: any) => {
                  // console.log('he;;;p');
                  // console.log(row);
                  if (row.orderStatus === 'draft') {
                    fetchOrderDetails(row.inventoryOrderId);
                  } else {
                    navigate(
                      `/inventory/material-transfer-po/${row.inventoryOrderId}`
                    );
                  }
                }}
                handleStatus={() => {}}
                paginationModel={{
                  page: paginate.offset,
                  pageSize: paginate.limit,
                }}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
              />
            </Paper>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
      <SimpleDialogComponent
        title={'Dispatch Order'}
        dialogContent={DisptachDialogView()}
        open={disptachDialogViewOpen}
        handleClose={() => {
          setDisptachDialogViewOpen(false);
          setCurrentDestination(0);
          setCurrentLocation(0);
          setNonQuotedItems([]);
          setQuotedItems([]);
          setCurrentRecord(null);
          changeTabHandler(0);
        }}
      />
      <SimpleDialogComponent
        title={'Purchase order'}
        dialogContent={PODialogView()}
        open={PODialogViewOpen}
        handleClose={() => {
          setPODialogViewOpen(false);
          clearPOForm();
        }}
      />
      {
        <SimpleDialogComponent
          title={'Purchase Order Request'}
          dialogContent={dialogPOSend()}
          open={POSendDailogOpen}
          handleClose={() => {
            setPOSendDailogOpen(false);
            clearPOForm();
          }}
        />
      }
      <SimpleDialogComponent
        title={'Confirmation'}
        dialogContent={dialogConfirmation()}
        open={confirmDailogOpen}
        handleClose={() => {
          setConfirmDailogOpen(false);
        }}
      />
      <SimpleDialogComponent
        title={'Transfer item'}
        dialogContent={transferDialogView()}
        open={transferDialogViewOpen}
        handleClose={() => {
          setTransferDialogViewOpen(false);
        }}
      />
    </Stack>
  );
};

export default MaterialTransferPO;
